<div class="workflow-picker">
    <div class="header c-main-color c-main-bgcolor">
        <h1>{{::header}}</h1>
    </div>
    <div class="pick-and-select">
        <div class="picker-sidebar">
            <div c-search-box search-state='references.search' class="search"></div>
            <div class="links">
                <ul>
                    <li ng-repeat="module in wpCtrl.modulesAsArray2 track by $index" ng-class="{selected: module.selected}"><a ng-click="wpCtrl.quickLinkClick(module)">{{module.label}}</a></li>
                </ul>
            </div>
            <div class="tree">
                <c-tree-explorer class="display-tree" config="wpCtrl.tagTreeConfig"></c-tree-explorer>
            </div>
        </div>
        <div class="documents-list">
            <c-list config="wpCtrl.workflowPickerConfig" selected-item-ids="wpCtrl.workflowPickerConfig.selectedItemIds"></c-list>
        </div>
    </div>
    <div class="selected-documents-header c-main-color c-main-bgcolor">
        <h3>{{::selectedHeader}}</h3>
    </div>
    <div class="selected-documents">
        <c-list config="wpCtrl.workflowSelectedConfig"></c-list>
    </div>
    <div class="button-bar" style="text-align:right;left:0;right:0;margin-top:5px">
        <button class="popup-msg-button btn-primary" ng-click="actionOk()">
            <span>{{'popup.ok'|translate}}</span>
        </button>
        <button class="popup-msg-button" ng-click="actionCancel()">
            <span>{{'popup.cancel'|translate}}</span>
        </button>
    </div>
</div>